import axiosInstance from "../lib/axiosInstance";


const StudentList = class {
    constructor() {
      this.baseUrl = "adminapi/student";
    }
    
    async Getlists() {
        return await axiosInstance.get(`${this.baseUrl}`)
    }
// student list by parent id
    async StudentListbyParentId (id){
      return await axiosInstance.get(`${this.baseUrl}?pid=${id}`)
    } 
   
};
export default new StudentList();